<template>
	<div style="background-color: var(--color-bg-default); position: absolute; top: 0; bottom: 0; right: 0; left: 0">
		<el-container style="height: 100%">
			<el-header style="padding: 0">
				<headerTem></headerTem>
			</el-header>
			<el-container style="flex: 1; overflow: hidden">
				<el-aside width="70px" style="height: 100%">
					<leftTem></leftTem>
				</el-aside>
				<el-container style="width: 100%">
					<el-main style="padding: 0">
						<contentTem></contentTem>
					</el-main>
				</el-container>
			</el-container>
			<el-footer v-if="layoutStore.showFooter" style="height: 50px; border-top: 1px solid var(--el-color-info-light-9)" class="row xy_center">
				<footerTem></footerTem>
			</el-footer>
		</el-container>
		<!-- 系统启动加载组件 -->

		<StartLoading />
	</div>
</template>

<script>
import { useLayoutStore } from "../../stores/layout";
import leftTem from "./components/left/index.vue";
import headerTem from "./components/header/index.vue";
import contentTem from "./components/content/index.vue";
import footerTem from "./components/footer/index.vue";
export default {
	name: "SunAdminLayout",
	components: { leftTem, contentTem, headerTem, footerTem },
	data() {
		return {};
	},
	methods: {},
	computed: {
		layoutStore() {
			return useLayoutStore();
		},
	},
};
</script>

<style></style>
